import * as React from "react";

import { ConnectProto } from "@racoon/api";

import type { EditedJobs } from "../model/edited-jobs";

/** Renders `children` with the latest edit of `job`, re-rendering on every edit. */
export const LiveJob: React.FC<{
  edited: EditedJobs;
  job: ConnectProto.Job;
  children: (job: ConnectProto.Job) => React.ReactNode;
}> = ({ edited, job, children }) => {
  const live = React.useSyncExternalStore(edited.subscribe, () => edited.get(job));
  return <>{children(live)}</>;
};
